import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../js/charSequenceJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './StringBuilderJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb28h1l6umahrlb as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { isLettere1qnx5bysxbd as isLetter } from './charJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.vp_1 = new (BytesHexFormat())(2147483647, 2147483647, '  ', '', '', '');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.wp_1 = new (NumberHexFormat())('', '', false, 1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var BytesHexFormatClass;
function BytesHexFormat() {
  if (BytesHexFormatClass === VOID) {
    class $ {
      constructor(bytesPerLine, bytesPerGroup, groupSeparator, byteSeparator, bytePrefix, byteSuffix) {
        Companion_getInstance();
        this.mp_1 = bytesPerLine;
        this.np_1 = bytesPerGroup;
        this.op_1 = groupSeparator;
        this.pp_1 = byteSeparator;
        this.qp_1 = bytePrefix;
        this.rp_1 = byteSuffix;
        this.sp_1 = (this.mp_1 === 2147483647 && this.np_1 === 2147483647);
        var tmp = this;
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.qp_1;
        if (charSequenceLength(this_0) === 0) {
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = this.rp_1;
          tmp_1 = charSequenceLength(this_1) === 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.pp_1.length <= 1;
        } else {
          tmp_0 = false;
        }
        tmp.tp_1 = tmp_0;
        this.up_1 = isCaseSensitive(this.op_1) || isCaseSensitive(this.pp_1) || isCaseSensitive(this.qp_1) || isCaseSensitive(this.rp_1);
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        // Inline function 'kotlin.text.appendLine' call
        this_0.m1('BytesHexFormat(').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.xp(this_0, '    ').o1(_Char___init__impl__6a9atx(10));
        this_0.m1(')');
        return this_0.toString();
      }
      xp(sb, indent) {
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.m1(indent).m1('bytesPerLine = ').rg(this.mp_1).m1(',').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.m1(indent).m1('bytesPerGroup = ').rg(this.np_1).m1(',').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.m1(indent).m1('groupSeparator = "').m1(this.op_1).m1('",').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.m1(indent).m1('byteSeparator = "').m1(this.pp_1).m1('",').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.m1(indent).m1('bytePrefix = "').m1(this.qp_1).m1('",').o1(_Char___init__impl__6a9atx(10));
        sb.m1(indent).m1('byteSuffix = "').m1(this.rp_1).m1('"');
        return sb;
      }
    }
    initMetadataForClass($, 'BytesHexFormat');
    BytesHexFormatClass = $;
  }
  return BytesHexFormatClass;
}
var NumberHexFormatClass;
function NumberHexFormat() {
  if (NumberHexFormatClass === VOID) {
    class $ {
      constructor(prefix, suffix, removeLeadingZeros, minLength) {
        Companion_getInstance_0();
        this.yp_1 = prefix;
        this.zp_1 = suffix;
        this.aq_1 = removeLeadingZeros;
        this.bq_1 = minLength;
        var tmp = this;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.yp_1;
        if (charSequenceLength(this_0) === 0) {
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = this.zp_1;
          tmp_0 = charSequenceLength(this_1) === 0;
        } else {
          tmp_0 = false;
        }
        tmp.cq_1 = tmp_0;
        this.dq_1 = (this.cq_1 && this.bq_1 === 1);
        this.eq_1 = isCaseSensitive(this.yp_1) || isCaseSensitive(this.zp_1);
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        // Inline function 'kotlin.text.appendLine' call
        this_0.m1('NumberHexFormat(').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.xp(this_0, '    ').o1(_Char___init__impl__6a9atx(10));
        this_0.m1(')');
        return this_0.toString();
      }
      xp(sb, indent) {
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.m1(indent).m1('prefix = "').m1(this.yp_1).m1('",').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        sb.m1(indent).m1('suffix = "').m1(this.zp_1).m1('",').o1(_Char___init__impl__6a9atx(10));
        var tmp0 = sb.m1(indent).m1('removeLeadingZeros = ').qg(this.aq_1);
        // Inline function 'kotlin.text.appendLine' call
        var value = _Char___init__impl__6a9atx(44);
        // Inline function 'kotlin.text.appendLine' call
        tmp0.o1(value).o1(_Char___init__impl__6a9atx(10));
        sb.m1(indent).m1('minLength = ').rg(this.bq_1);
        return sb;
      }
    }
    initMetadataForClass($, 'NumberHexFormat');
    NumberHexFormatClass = $;
  }
  return NumberHexFormatClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.hp_1 = new (HexFormat())(false, Companion_getInstance().vp_1, Companion_getInstance_0().wp_1);
        this.ip_1 = new (HexFormat())(true, Companion_getInstance().vp_1, Companion_getInstance_0().wp_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var HexFormatClass;
function HexFormat() {
  if (HexFormatClass === VOID) {
    class $ {
      constructor(upperCase, bytes, number) {
        Companion_getInstance_1();
        this.jp_1 = upperCase;
        this.kp_1 = bytes;
        this.lp_1 = number;
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        // Inline function 'kotlin.text.appendLine' call
        this_0.m1('HexFormat(').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        this_0.m1('    upperCase = ').qg(this.jp_1).m1(',').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.m1('    bytes = BytesHexFormat(').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.kp_1.xp(this_0, '        ').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.m1('    ),').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.m1('    number = NumberHexFormat(').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this.lp_1.xp(this_0, '        ').o1(_Char___init__impl__6a9atx(10));
        // Inline function 'kotlin.text.appendLine' call
        this_0.m1('    )').o1(_Char___init__impl__6a9atx(10));
        this_0.m1(')');
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'HexFormat');
    HexFormatClass = $;
  }
  return HexFormatClass;
}
function isCaseSensitive(_this__u8e3s4) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.text.any' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
      var element = charSequenceGet(_this__u8e3s4, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (Char__compareTo_impl_ypi4mb(element, _Char___init__impl__6a9atx(128)) >= 0 || isLetter(element)) {
        tmp$ret$0 = true;
        break $l$block;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
//region block: exports
export {
  Companion_getInstance_1 as Companion_getInstanceymhgfdhph325,
};
//endregion

//# sourceMappingURL=HexFormat.mjs.map
